

































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import graph3dImport from '../../dv-pure-render/graph-3d/graph-3d.js';
let graph3d: any = graph3dImport;

import CommonStore from '@/store/CommonStore';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';
import qs from 'qs';

@Component({
    components: {}
})
export default class App extends Vue {
    @Prop({})
    isShow: any;
    targetView = '2d'; // transition

    commonStore = CommonStore.state;
    searchData = SearchStore.state;
    detailData = DetailStore.state;
    // graph3dHelper:any = {};
    graph3dHelper:any;
    cameraToSave: any;
    showPoiId: string = '1008936689613152277';
    isStop:boolean = false;
    relatedPOI: any;
    rootNode: any;
    cancelToken: any;
    aef: any;
    endAef: any;
    keydownListener = null;

    get poiGraph3d () {return this.detailData.poiGraph3d}
    get poiData3d () {return this.detailData.poiData3d}

    drawGraph3d (data) {
        this.graph3dHelper = new graph3d({
            dom: this.$refs.graph3d,
            data: data,
            eventBus: this.$bus,
            rootId: this.poiData3d.rootId,
        });
        let camToSave = {
            position: this.graph3dHelper.camera.position.clone(),
            rotation: this.graph3dHelper.camera.rotation.clone(),
            controlCenter: this.graph3dHelper.controls.target.clone(),
        };
        this.cameraToSave = camToSave;
        console.log('cameraToSave', camToSave.position.z);

        // this.aef();
    }

    @Watch('poiGraph3d')
    onPoiGraph3dChange (newVal, oldVal) {
        // hack
        if (newVal !== oldVal && newVal.nodes) {
            this.drawGraph3d(newVal);
        }
    }

    async goToNode (id = this.poiData3d.rootId) {
        this.graph3dHelper.cutToNode(id);
    }

    goTo2d() {
        console.log('3d-stop');
        // window['autoAnimation'] = false;
        window['runingTo2d'] = true;
        this.cancelToken.abort();
        this.destoryed();

        const queryObj = qs.parse(location.search.slice(1));
        if (queryObj.auto) {
        // if (sessionStorage.getItem('mode') === 'auto') {
            this.$bus.$emit('view-change', '3d', '2d', false);
        } else {
            this.$bus.$emit('view-change', '3d', '2d', true);
        }
    }

    darkSpriteText(relatedPOI) {
        relatedPOI.forEach(poi => {
            let threeObj = poi.__threeObj;
            let sprite = threeObj && threeObj.children.filter(obj => {
                return obj.type === 'Sprite';
            });
            sprite[0].color = 'rgba(255,255,255, 0)';
        });
    }

    hightLightSpriteText(relatedPOI) {
        relatedPOI.forEach(poi => {
            let threeObj = poi.__threeObj;
            let sprite = threeObj && threeObj.children.filter(obj => {
                return obj.type === 'Sprite';
            });
            sprite[0].color = 'rgba(255,255,255, 1)';
            sprite[0].textHeight = 18;

        });
    }

    *animateScript() {
        const queryObj = qs.parse(location.search.slice(1));
        if ($qsObj.quick3d === 'true') {
            yield this.$sleep(1000 * 2);
            if (queryObj.auto) {
                this.$bus.$emit('view-change', '3d', this.targetView);
            }
            if (Date.now() > 0) {return void 0;}
        }
        if (window['_screenType'] === '2160') {
            yield this.$sleep(20000);
        } else {
            yield this.$sleep(10000);
        }
        let relatedPOI = this.graph3dHelper && this.graph3dHelper.data.nodes.filter(node => {
            return node && node.depth === '0';
        });
        this.darkSpriteText(relatedPOI);
        this.graph3dHelper.controls.autoRotate = false;
        let cameraPosition = this.graph3dHelper.camera.position;
        let rootIndex = relatedPOI.findIndex(node => {
            return node.id === this.poiData3d.rootId;
        });
        let rootNode = relatedPOI.splice(rootIndex, 1)[0];
        this.rootNode = rootNode;
        relatedPOI.unshift(rootNode);
        console.log('relatedPOI', relatedPOI);
        let poi3d = 4;
        if (window['_screenType'] === '2160') {
            let item = relatedPOI[7];
            relatedPOI[7] = relatedPOI[1];
            relatedPOI[1] = item;
            item = relatedPOI[6];
            relatedPOI[6] = relatedPOI[2];
            relatedPOI[2] = item;
            item = relatedPOI[8];
            relatedPOI[8] = relatedPOI[3];
            relatedPOI[3] = item;
            this.relatedPOI = relatedPOI;
            this.graph3dHelper.moonTweenA.stop();
            poi3d = $qsObj.poi3d ? $qsObj.poi3d : $qsObj.quickall === 'true' ? 2 : 5;
        } else {
            let item = relatedPOI[6];
            relatedPOI[6] = relatedPOI[2];
            relatedPOI[2] = item;
            this.relatedPOI = relatedPOI;
            this.graph3dHelper.moonTweenA.stop();
            poi3d = $qsObj.poi3d ? $qsObj.poi3d : $qsObj.quickall === 'true' ? 2 : 4;
        }

        for (let i = 0; i < poi3d; i++) {
            let poi = relatedPOI[i];
            this.hidePoiOther(poi.id);
            this.goToNode(relatedPOI[i].id);
            let threeObj = poi.__threeObj;
            let sprite = threeObj.children.filter(obj => {
                return obj.type === 'Sprite';
            });
            sprite[0].color = 'rgba(255,255,255, 1)';
            sprite[0].textHeight = 10;
            if (window['_screenType'] === '2160') {
                sprite[0].textHeight = 8;
                yield this.$sleep(6000);
            } else {
                sprite[0].textHeight = 10;
                yield this.$sleep(4000);
            }

            if ( i !== relatedPOI.lenghth - 1) {
                sprite[0].color = 'rgba(255,255,255, 0)';
            }
            this.showPoiOther(poi.id);
        }

        this.hightLightSpriteText(relatedPOI);
        this.graph3dHelper.moonTweenA.start();

        this.resetCamera(cameraPosition, this.cameraToSave.rotation, this.cameraToSave.controlCenter);
        // 3000
        let tween = new TWEEN.Tween(cameraPosition).to({
            z: this.cameraToSave.position.z,
            y: cameraPosition.y,
            x: cameraPosition.x,
        }, 2000)
            .start()
            .onComplete( () => {
                // if(sessionStorage.getItem('mode') === 'auto') {
                if (queryObj.auto) {
                    this.endAnimate();
                } else {
                    this.graph3dHelper.controls.autoRotate = true;
                    this.graph3dHelper.controls.autoRotateSpeed = -1.0;
                    this.cancelToken = new this.$ae.CancelToken();
                    this.aef = this.$ae(this.animateScript, this.cancelToken);
                    this.aef();
                }
                TWEEN.remove(tween);
            });
    }

    async endAnimate() {
        this.graph3dHelper.controls.autoRotate = true;
        this.graph3dHelper.controls.autoRotateSpeed = -1.0;
        await this.$sleep(3000);
        if (!this.graph3dHelper) {
            return;
        }
        await this.graph3dHelper.showGoldParticle();
        this.$bus.$emit('view-change', '3d', this.targetView);
        await this.$sleep(2000);
        this.destoryed();
    }

    destoryed() {
        this.graph3dHelper.stopAnimate();
        this.graph3dHelper.destroyed();
        this.graph3dHelper = null;
        this.rootNode = null;
        this.relatedPOI = null;
    }

    beforeDestroy() {
        document.removeEventListener('keydown', this.keydownListener);
    }
    resetCamera(position, rotation, controlCenter) {
        if (this.graph3dHelper) {
            this.graph3dHelper.camera.position.set(position.x, position.y, position.z);
            this.graph3dHelper.camera.rotation.set(rotation.x, rotation.y, rotation.z);
            this.graph3dHelper.controls.target.set(controlCenter.x, controlCenter.y, controlCenter.z);
            this.graph3dHelper.controls.update();
        }
    }

    async loopScript() {
        if ($qsObj.quick3d === 'true') {
            await this.$sleep(1000 * 2);
            this.$bus.$emit('view-change', '3d', this.targetView);
            if (Date.now() > 0) {return void 0;}
        }

        // 再次复原一次，以防跳转离开时，并未进行复原
        // this.graph3dHelper.hideGoldParticle();
        // this.graph3dHelper.moonTweenA.start();
        this.graph3dHelper.resumeAnimation();
        this.isStop = false;
        let cameraPosition = this.graph3dHelper.camera.position;
        this.resetCamera(cameraPosition, this.cameraToSave.rotation, this.cameraToSave.controlCenter);
        let tween = new TWEEN.Tween(cameraPosition).to({
            z: this.cameraToSave.position.z,
            y: this.cameraToSave.position.y,
            x: this.cameraToSave.position.x,
        }, 1000)
            .start()
            .onComplete( async () => {
                this.graph3dHelper.controls.autoRotate = true;
                this.graph3dHelper.controls.autoRotateSpeed = -1.0;
                this.aef();
                TWEEN.remove(tween);
            });
    }
    showPoiOther(poiID) {
        let {nodes, links} = this.getHideData(poiID);
        nodes.forEach((node) => {
            node.__threeObj.visible = true;
        });

        links.forEach((link) => {
            link.__lineObj.visible = true;
        });
    }
    hidePoiOther(poiID) {
        let {nodes, links} = this.getHideData(poiID);
        nodes.forEach((node) => {
            node.__threeObj.visible = false;
        });

        links.forEach((link) => {
            link.__lineObj.visible = false;
        });
    }
    getHideData(poiID) {
        let graphData = this.graph3dHelper.data;
        let {links, nodes} = graphData;

        let realPoiNodeId = poiID;
        nodes.forEach(node => {
            // 用split
            if (node.id.includes(poiID)) {
                realPoiNodeId = node.id;
            }
        });

        let hideLinks = [];
        let hideNodes = [];

        hideNodes = nodes.filter(node => {
            if (node.rootId === realPoiNodeId && !node.isCommonRoute && node.depth !== '0') {
                return true;
            }
        });
        let hideNodeIds = hideNodes.map(_ => _.id);

        hideLinks = links.filter(link => {
            if (hideNodeIds.includes(link.source.id) || hideNodeIds.includes(link.target.id)) {
                return true;
            }
        });

        return {
            links: hideLinks,
            nodes: hideNodes
        };
    }

    keydownListenerMemoize() {
        let tmp;
        return (e) => {
            let key = e.key.toLowerCase();
            if ( key === 'c' ) {
                tmp = key;
            } else {
                tmp += key;
            }
            if (tmp === 'c2') {
                this.goTo2d();
            }
        }
    }
    mounted() {
        this.keydownListener = this.keydownListenerMemoize();
        document.addEventListener('keydown', this.keydownListener);
        DetailStore.getGraph3d();
        // if (this.detailData.poiGraph3d && this.detailData.poiGraph3d.nodes) {
        //     this.drawGraph3d(this.detailData.poiGraph3d);
        // }
        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.animateScript, this.cancelToken);


        // if (this.isShow) {
        //     this.aef();
        // }
        // this.$bus.$on('3d-start', () => {
        //     if (this.isShow) {
        //         this.cancelToken = new this.$ae.CancelToken();
        //         this.aef = this.$ae(this.animateScript, this.cancelToken);
        //         this.loopScript();
        //     }
        // });
        // this.$autoOn('show-3d-scene', (counter) => {
        //     let cn = this.$refs.graph3d as HTMLElement;
        //     cn.style.opacity = (counter / 30).toString();
        // })
         this.$autoOn('show-3d-scene', (counter) => {
            let cn = this.$refs.graph3d as HTMLElement;
            cn.style.opacity = '1';
        })

        this.$autoOn('action-script-stop-common', () => {
            if (this.isShow) {
                this.isStop = true;
                if (this.relatedPOI) {
                    this.hightLightSpriteText(this.relatedPOI);
                }
                if (this.graph3dHelper && this.graph3dHelper.controls) {
                    this.graph3dHelper.controls.autoRotate = false;
                }
                this.cancelToken.abort();
            }
        });
        this.$autoOn('action-script-start', () => {

            if (this.isShow) {
                this.cancelToken.abort();
                if (this.relatedPOI) {
                    this.hightLightSpriteText(this.relatedPOI);
                }
                this.cancelToken = new this.$ae.CancelToken();
                this.aef = this.$ae(this.animateScript, this.cancelToken);
                this.loopScript();
            }
        });
        this.$autoOn('move-camera', (zPosition) => {
            this.cameraToSave.position.z = zPosition;
        });

        this.$autoOn('3d-action-start', () => {
            this.aef();
        });
    }
}
